import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Typography,
  Row,
  Col,
  Input,
  Form,
  Checkbox,
  Table,
  Radio,
  Modal,
  message,
  Icon,
  Button,
  Avatar,
} from "antd";
import moment from "moment";
import FromInput from "../../../../../components/user/from/Input";
import { changeFormatdate } from "../../../../../utils/formatdate";
import { alertMessage } from "../../../../../utils/message";
import { checkLinkURL } from "../../../../../utils/auth";

const { TextArea } = Input;
const { Text, Title } = Typography;
class WelfareListPaymentVictimSecAttachment extends Component {
  state = {
    loading: false,
    dataTalbeUploads: [],
    loadingFullpage: true,
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        align: "center",
        render: (item, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "ประเภทเอกสาร",
        dataIndex: "documentType",
        align: "center",
        render: (item, record, index) => (
          <span>
            {this.props.isViewOnly ? (
              item ? (
                item
              ) : (
                "-"
              )
            ) : (
              <>
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].documentType`,
                    {
                      initialValue: item ? item : "เอกสารประกอบการเบิกเงินช่วยเหลือผู้ประสบภัยพิบัติ",
                      rules: [
                        {
                          required: true,
                          message: "กรุณาระบุเอกสาร",
                        },
                      ],
                    }
                  )(
                    <Input
                      // defaultValue={item}
                      // style={{ width: "150px" }}
                      disabled={
                        this.props.isViewOnly || record.id ? true : false
                      }
                      onBlur={(e) =>
                        this.onChangeValueForm(index, e, "documentType")
                      }
                    />
                  )}
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }} hidden>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].fileType`,
                    {
                      initialValue: record.fileType ? record.fileType : null,
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุเอกสาร",
                        },
                      ],
                    }
                  )(<Input />)}
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }} hidden>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].filePath`,
                    {
                      initialValue: record.filePath ? record.filePath : null,
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุเอกสาร",
                        },
                      ],
                    }
                  )(<Input />)}
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }} hidden>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].fileName`,
                    {
                      initialValue: record.fileName ? record.fileName : null,
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุเอกสาร",
                        },
                      ],
                    }
                  )(<Input />)}
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }} hidden>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].relatedTable`,
                    {
                      initialValue: record.relatedTable
                        ? record.relatedTable
                        : "wfDisasterHd",
                      rules: [
                        {
                          required: false,
                          message: "กรุณาระบุเอกสาร",
                        },
                      ],
                    }
                  )(<Input />)}
                </Form.Item>
                <Form.Item style={{ marginBottom: "0px" }} hidden>
                    {this.props.form.getFieldDecorator(
                      `disasterAttachfile[${index}].isDeleted`,
                      {
                        initialValue: record.isDeleted ? record.isDeleted : false,
                        rules: [
                          {
                            required: false,
                            message: "กรุณาระบุเอกสาร",
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>

                {!record.id && (
                  <Form.Item style={{ marginBottom: "0px" }} hidden>
                    {this.props.form.getFieldDecorator(
                      `disasterAttachfile[${index}].base64`,
                      {
                        initialValue: record.base64 ? record.base64 : null,
                        rules: [
                          {
                            required: false,
                            message: "กรุณาระบุเอกสาร",
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>
                )}
                {record.id && (
                  <Form.Item style={{ marginBottom: "0px" }} hidden>
                    {this.props.form.getFieldDecorator(
                      `disasterAttachfile[${index}].id`,
                      {
                        initialValue: record.id ? record.id : null,
                        rules: [
                          {
                            required: false,
                            message: "กรุณาระบุเอกสาร",
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>
                )}
              </>
            )}
          </span>
        ),
      },
      {
        title: "รายละเอียดเอกสาร",
        dataIndex: "description",
        align: "center",
        render: (item, record, index) => (
          <div align="left">
            <span>
              {this.props.isViewOnly ? (
                item ? (
                  item
                ) : (
                  "-"
                )
              ) : (
                <Form.Item style={{ marginBottom: "0px" }}>
                  {this.props.form.getFieldDecorator(
                    `disasterAttachfile[${index}].description`,
                    {
                      initialValue: item ? item : null,
                      rules: [
                        {
                          required: true,
                          message: "กรุณาระบุรายละเอียดเอกสาร",
                        },
                      ],
                    }
                  )(
                    <Input
                      // defaultValue={item}
                      // style={{ width: "150px" }}
                      disabled={
                        this.props.isViewOnly || record.id ? true : false
                      }
                      onBlur={(e) =>
                        this.onChangeValueForm(index, e, "description")
                      }
                    />
                  )}
                </Form.Item>
              )}
            </span>
          </div>
        ),
      },
      {
        title: "เอกสารแนบ",
        dataIndex: "fileName",
        width: "200px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              { record.id && item
                ? this.showMoreFileUploads(index, record)
                : this.inputFormUploads(index, record)}
            </>
          );
        },
      },
      {
        title: "จัดการ",
        dataIndex: "action",
        hidden: this.props.isViewOnly,
        render: (item, record, index) => {
          return this.showDetailBtnInput(
            record,
            index,
            record.id ? record.id : null
          );
        },
      },
    ].filter((item) => !item.hidden),
  };

  showDetailBtnInput = (record, arrayId, id = null) => {
    const { dataTalbeUploads } = this.state;
    const { detailForm } = this.props;
    return (
      <>
        {console.log("record Showdetail", record)}

        {id ? (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            onClick={() =>
              id
                ? // this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
                  this.showModalFormConfirm(
                    record,
                    "ท่านต้องการลบข้อมูล?",
                    "",
                    "ยืนยัน",
                    arrayId,
                    id,
                    record
                  )
                : this.destroyArrayDataUploads(arrayId, id, record)
            }
            // disabled={true}
            style={{
              cursor: "pointer",
              background: "red",
            }}
          />
        ) : (
          <div className="flex">
            {/* {record.isShowEditButton && (
              <Avatar
                shape="square"
                icon={<Icon type="edit" />}
                className="mr-2 mb-1"
                style={{ cursor: "pointer", backgroundColor: "#36699E" }}
                onClick={() =>
                  record.isNew && this.enableToEdit(arrayId, record)
                }
              />
            )}
            {record.isShowSaveButton && (
              <Avatar
                shape="square"
                icon={<Icon type="save" />}
                className="mr-2 mb-1"
                style={{ cursor: "pointer", backgroundColor: "#36699E" }}
                onClick={() => record.isNew && this.checkBeforeAddRow(arrayId)}
              />
            )} */}

            <Avatar
              shape="square"
              icon={<Icon type="delete" />}
              className="mr-1 mb-1 bg-red"
              onClick={() =>
                id
                  ? // this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
                    this.showModalFormConfirm(
                      record,
                      "ท่านต้องการลบข้อมูล?",
                      "",
                      "ยืนยัน",
                      arrayId,
                      id
                    )
                  : this.destroyArrayDataUploads(arrayId, id)
              }
              style={{ cursor: "pointer", background: "red" }}
            />
          </div>
        )}
        {/* ) : (
          <Avatar
            shape="square"
            icon={<Icon type="delete" />}
            className="mr-1 mb-1 bg-red"
            onClick={() =>
              //this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
              this.showModalFormConfirm(
                record,
                "ท่านต้องการลบข้อมูล?",
                "",
                "ยืนยัน",
                arrayId,
                studyLearnRecordId
              )
            }
            style={{ cursor: "not-allowed" }}
            disabled={true}
          />
        )} */}
      </>
    );
  };
  // checkBeforeAddRow = async (arrayId) => {
  //   const { dataTalbeUploads } = this.state;
  //   const { form } = this.props;

  //   const tableValue = dataTalbeUploads.map((obj, _index) => ({
  //     ...obj,
  //     ...this.props.form.getFieldsValue(),
  //   }));

  //   // await this.setState({ disabledAdd: true });

  //   console.log("tableValue", tableValue);
  //   let lastRowValue = null;
  //   if (arrayId == "new") {
  //     console.log("arrayId = -1", arrayId);
  //     lastRowValue = tableValue[dataTalbeUploads.length - 1];
  //   } else {
  //     console.log("arrayId != -1");
  //     lastRowValue = tableValue[arrayId];
  //   }

  //   // console.log("lastRowValue", lastRowValue);

  //   let errorValue = false;

  //   if (
  //     lastRowValue.description == "" ||
  //     lastRowValue.documentType == "" ||
  //     !lastRowValue.file
  //   ) {
  //     errorValue = true;
  //     //TODO : specify empty field name in modal.error
  //     Modal.error({
  //       className: "modalFickIcons",
  //       title: "เพิ่มข้อมูลเอกสารแนบไม่สำเร็จ",
  //       width: "600px",
  //       content: <h3 className="mt-3">กรุณาระบุรายละเอียดเอกสารแนบให้ครบถ้วน</h3>,
  //       okText: "ปิด",
  //       onOk() {},
  //     });
  //   }

  //   if(!errorValue){
  //      this.handleEditRow(arrayId);
  //   }

  // };

  // handleEditRow = async (arrayId) => {
  //   const { dataTalbeUploads } = this.state;
  //   const { form } = this.props;

  //   let getTimeDetail = form.getFieldValue();

  //   const mergeData = getTimeDetail.map((obj, _index) => ({
  //     ...obj,
  //     //...formRef.current.getFieldsValue()?.studyScholarship.studyScholarshipDetail[_index],
  //     // studyExtendRound: _index + 1,
  //     // studyExtendSort: _index + 1,
  //     disabledRow:
  //       _index == arrayId ? true : obj.isValidate == false ? false : true,
  //     isShowEditButton:
  //       _index == arrayId ? true : obj.isValidate == false ? false : true,
  //     isShowSaveButton:
  //       _index == arrayId ? false : obj.isValidate == false ? true : false,
  //     isValidate:
  //       _index == arrayId ? true : obj.isValidate == false ? false : true,
  //   }));

  //   await this.setState({ dataTalbeUploads: mergeData });

  //   form.setFieldsValue({
  //     tbAbstainTimeDt: mergeData,
  //   });

  //   // let enableAddButton = true;
  //   // mergeData.map((resultObj, _index) => {
  //   //   if (!resultObj.isValidate) {
  //   //     enableAddButton = false;
  //   //   }
  //   // });

  //   // if (enableAddButton) {
  //   //   await this.setState({ disabledAdd: false });
  //   // } else {
  //   //   await this.setState({ disabledAdd: true });
  //   // }
  // };

  onChangeValueForm = async (arrayId, values, name) => {
    const { dataTalbeUploads } = this.state;
    let dataSourceitems = [...this.state.dataTalbeUploads];
    let item = { ...dataSourceitems[arrayId] };

    console.log("item onchange values", values);
    console.log("item onchange name", name);
    console.log("item onchange", item);
    if (name == "documentType") {
      item.documentType = values.target.value;
    } else if (name == "description") {
      item.description = values.target.value;
    } else if (name == "file") {
      item.file = values;
    }
    dataSourceitems[arrayId] = item;

    console.log("dataSourceitems", dataSourceitems);
    await this.setState(
      {
        dataTalbeUploads: dataSourceitems,
      },
      async () => {
        // await this.setSummary()
        // this.cllBackSetValueContactNumber()
      }
    );

    // this.props.onTableChange(dataSourceitems);
  };

  convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  inputFormUploads = (arrayId, record) => {
    const { dataTalbeUploads } = this.state;
    let fileName = dataTalbeUploads[arrayId].file
      ? dataTalbeUploads[arrayId].file.name
      : "";
    console.log("record", record);
    console.log("inputFormUploads", +arrayId);
    console.log("inputFormUploads file", dataTalbeUploads[arrayId]);
    return (
      <>
        {record.fileId ? (
          record.file && (
            <Text
              onClick={() => {
                this.modalShowFileDatabase(record, "เอกสาร");
              }}
              style={{ cursor: "pointer" }}
              className="btn-show-fileuploads"
            >
              ดูไฟล์อัปโหลด
              {console.log("inputFormUploads case1")}
            </Text>
          )
        ) : (
          <>
            {console.log("inputFormUploads case2 array:" + arrayId)}
            {console.log("disableRoww upload", record.disabledRow)}

            <Form.Item label={""} style={{ marginBottom: "0px" }}>
              {this.props.form.getFieldDecorator(
                `disasterAttachfile[${arrayId}].file`,
                {
                  //initialValue: item ? item : null,
                  // rules: [
                  //   {
                  //     required: true,
                  //     //message: "กรุณาอัพโหลดไฟล์",
                  //     className: "height-input-menu",
                  //     valuePropName: "fileList",
                  //   },
                  // ],
                }
              )(
                <>
                  {!record.disabledRow ? (
                    <label
                      for={"input-file-" + arrayId}
                      class="custom-file-upload"
                      style={{ lineHeight: 1.5 }}
                    >
                      <p
                        className="py-2 px-4 mb-0"
                        align={"center"}
                        style={{ backgroundColor: "#8d0e14", color: "#fff" }}
                      >
                        อัปโหลด
                      </p>
                      <p style={{ fontSize: "12px" }} className="my-2">
                        แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                      </p>
                    </label>
                  ) : (
                    <label style={{ lineHeight: 1.5 }}>
                      <p
                        className="py-2 px-4 mb-0"
                        align={"center"}
                        style={{ backgroundColor: "#E3E3E3", color: "#fff" }}
                      >
                        อัปโหลด
                      </p>
                      <p style={{ fontSize: "12px" }} className="my-2">
                        แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf
                      </p>
                    </label>
                  )}
                  <p
                    className={fileName ? "" : "color-red"}
                    style={{ lineHeight: 1.2 }}
                  >
                    {!fileName && (
                      <p id={"showTextUplodas" + arrayId}>
                        กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์
                      </p>
                    )}
                  </p>
                  <input
                    id={"input-file-" + arrayId}
                    className="input-file"
                    // name={uploadName}
                    type="file"
                    accept="file_extension"
                    accept="image/png, image/jpeg, application/pdf"
                    onChange={(e) => {
                      !record.disabledRow &&
                        this.handleAdd(e.target.files[0], arrayId);
                    }}
                  />
                </>
              )}
            </Form.Item>
            <span className={fileName ? "" : "color-red"}>
              {fileName ? (
                <Text
                  onClick={() => {
                    this.modalShowFileCreate(
                      dataTalbeUploads[arrayId].file,
                      "เอกสาร"
                    );
                  }}
                  style={{ cursor: "pointer" }}
                  className="btn-show-fileuploads"
                >
                  ดูไฟล์อัปโหลด
                </Text>
              ) : (
                <span id={"showTextUplodas" + arrayId}>
                  {/* กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์ */}
                </span>
              )}
            </span>
          </>
        )}
      </>
    );
  };

  showMoreFileUploads = (arrayId, uploadFile) => {
    const { formRef } = this.props;
    const { dataTalbeUploads, dataTalbeUploadsDocument, checkModal } =
      this.state;

    console.log("showMoreFileUploads" + arrayId);
    if (dataTalbeUploads[arrayId]?.filePath) {
      console.log("showMoreFileUploads filepath");
      return (
        <Text
          onClick={() => {
            this.modalShowFileCreate2(
              dataTalbeUploads[arrayId],
              "เอกสาร",
              arrayId
            );
          }}
          style={{ cursor: "pointer" }}
          className="btn-show-fileuploads"
        >
          ดูไฟล์เอกสารแนบ
        </Text>
      );
    } else {
      console.log("showMoreFileUploads no studyfilepath");
      return (
        <Text
          onClick={() => {
            this.modalShowFileCreate2(
              dataTalbeUploads[arrayId],
              "เอกสาร",
              arrayId
            );
          }}
          style={{ cursor: "pointer" }}
          className="btn-show-fileuploads"
        >
          ดูไฟล์เอกสารแนบ
        </Text>
      );
    }
  };

  handleAdd = async (images, arrayId) => {
    const { form } = this.props;
    const { dataTalbeUploads, reqAttachDayStatus } = this.state;
    console.log("value file changed");

    if (images) {
      const isLt2M = images.size / 1024 / 1024 < 1;
      console.log("out if file", images);
      if (
        images.type == "image/jpeg" ||
        images.type == "application/pdf" ||
        images.type == "image/png"
      ) {
        console.log("in if file", images);
        if (!isLt2M) {
          console.log("in if file 2", images);
          message.error("ไฟล์ขนาดใหญ่เกิน 1MB กรุณาระบุ ไฟล์ใหม่อีกครั้ง");
          let dataSourceitems = [...this.state.dataTalbeUploads];
          let item = { ...dataTalbeUploads[arrayId] };
          item = {
            documentType: item.documentType,
            description: item.description,
            // isShowEditButton: item.isShowEditButton,
            // isShowSaveButton: item.isShowSaveButton,
            // isValidate: item.isValidate,
            // isNew: item.isNew,
            file: null,
          };
          dataSourceitems[arrayId] = item;

          await this.setState(
            {
              dataTalbeUploads: dataSourceitems,
            },
            () => {
              // this.cllBackSetValueOrganizatuions()
            }
          );
        } else {
          console.log("in if file 3", images);
          let dataSourceitems = [...this.state.dataTalbeUploads];
          let item = { ...dataTalbeUploads[arrayId] }
          let base64item = await this.convertBase64(images)
          item = {
            documentType: item.documentType,
            description: item.description,
            disabledRow: item.disabledRow,
            // isShowEditButton: item.isShowEditButton,
            // isShowSaveButton: item.isShowSaveButton,
            // isValidate: item.isValidate,
            // isNew: item.isNew,
            filePath: images.filePath,
            fileName: images.name,
            fileType: images.type,
            file: images,
            base64: base64item.substring(base64item.indexOf(",") + 1),
          };
          dataSourceitems[arrayId] = item;

          //this.onChangeValueForm(arrayId, images, "file");

          console.log("studyRecord dataSourceitems ", dataSourceitems);

          await this.setState(
            {
              dataTalbeUploads: dataSourceitems,
            },
            () => {
              // this.cllBackSetValueOrganizatuions()
            }
          );

          const fieldsHandle = this.props.form.getFieldsValue();
          //const { studyRecord } = fields
          console.log("studyRecord fieldsupload", fieldsHandle);
          await form.setFieldsValue({
            disasterAttachfile: dataSourceitems,
          });
        }
      } else {
        console.log("else out if file", images);
        alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf");
      }
    }
  };

  showModalFormConfirm = async (
    values,
    messageShow,
    title,
    textBtnOK,
    arrayId,
    studyLearnRecordId,
    record
  ) => {
    const { form, client } = this.props;

    console.log("showmodalconfirm destroyArrayId", arrayId);
    console.log(
      "showmodalconfirm destroystudyLearnRecordId",
      studyLearnRecordId
    );

    console.log(
      "showmodalconfirm record",
      record
    );

    await this.setState({
      destroyArrayId: arrayId,
      destroyStudyLearnRecordId: studyLearnRecordId,
      deleteRecord: record,
      // ModalConfirmFormTitle: messageShow,
      // ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      // ModalConfirmFormBtnOk: textBtnOK,
      // ModalConfirmFormBtnCancel: "ยกเลิก",
      // ModalConfirmFormValue: values,
      //ModalConfirmFormSubmitToSend: this.destroyArrayDataUploads(arrayId, studyLearnRecordId)
    });
  };

  onClickToNewTab = (typeFile) => {
    const { linkNewTab } = this.state;

    console.log("onClickToNewTab linkNewTab", linkNewTab);
    if (typeFile !== "application/pdf") {
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          linkNewTab +
          '" style="max-width:100%;height:100%"/></div>'
      );
    } else {
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          linkNewTab +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate2 = async (dataFile, title, arrayId) => {
    // var url = URL.createObjectURL(dataFile)

    console.log("DATAFILE VIEW", dataFile);
    console.log(
      "DATAFILE VIEW full",
      checkLinkURL() + "benefit-api/" + dataFile.filePath
    );
    const reader = new FileReader();
    if (dataFile.fileType !== "application/pdf") {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={checkLinkURL() + "benefit-api/" + dataFile.filePath}
                      style={{ height: "100%" }}
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(
                          dataFile,
                          dataFile.fileType,
                          arrayId
                        )
                      }
                      className="icons-show-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      //  reader.readAsDataURL(dataFile)
      //  reader.onloadend = async (e) => {
      //      var dataURL = reader.result;
      //      await this.setState({
      //          linkNewTab: dataURL
      //      })

      Modal.info({
        className: "modalFickIcons",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "1000px",
        content: (
          <div>
            <hr></hr>
            <div className="mt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col
                  span={10}
                  className="mb-3 block_show_file"
                  style={{ display: "block" }}
                >
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <iframe
                      style={{ opacity: "0", height: "0" }}
                      style={{ display: "none" }}
                    ></iframe>
                    <a
                      onClick={() =>
                        this.onClickToNewTab2(
                          dataFile,
                          dataFile.fileType,
                          arrayId
                        )
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                    <br></br>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };
  onClickToNewTab2 = (dataFile, typeFile, arrayId) => {
    const { rawData } = this.props;
    //const { linkNewTab} = this.state
    console.log("onClickToNewTab2");
    console.log("onClickToNewTab2 typeFile", typeFile);

    if (typeFile !== "application/pdf") {
      console.log("onClickToNewTab2 non pdf");
      var win = window.open();
      win.document.write(
        '<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' +
          checkLinkURL() +
          "benefit-api/" +
          dataFile?.filePath +
          '" style="height:100%"/></div>'
      );
    } else {
      console.log(
        "onClickToNewTab2 pdf eiei",
        checkLinkURL() + "benefit-api/" + rawData[arrayId]?.filePath
      );
      var win = window.open();
      win.document.write(
        '<iframe src="' +
          checkLinkURL() +
          "benefit-api/" +
          dataFile?.filePath +
          '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
      );
    }
  };

  modalShowFileCreate = async (dataFile, title) => {
    const { linkNewTab } = this.state;
    var url = URL.createObjectURL(dataFile);
    const reader = new FileReader();

    console.log("modalShowFileCreate", dataFile.type);

    if (dataFile.type !== "application/pdf") {
      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        console.log("linkNewTab dataURL", dataURL);
        await this.setState({
          linkNewTab: dataURL,
        });

        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        padding: "10px 55px",
                      }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <img src={dataURL} className="zoom-in" />
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="icons-delect-images"
                      >
                        <Icon type="eye" style={{ color: "#fff" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    } else {
      console.log("modalShowFileCreate pdf", dataFile.type);

      reader.readAsDataURL(dataFile);
      reader.onloadend = async (e) => {
        var dataURL = reader.result;
        await this.setState({
          linkNewTab: dataURL,
        });
        Modal.info({
          className: "modalFickIcons pt-4",
          title: "ไฟล์อัปโหลดเอกสารแนบ",
          width: "800px",
          content: (
            <div>
              <hr></hr>
              <div className="pt-4">
                <Row gutter={16} type="flex" justify="left" align="top">
                  <Col span={8} style={{ display: "block" }}>
                    <div
                      style={{ width: "100%", height: "200px" }}
                      align="center"
                      className="block-show-image-modal"
                    >
                      <a
                        onClick={() => this.onClickToNewTab(dataFile.type)}
                        className="color-white"
                      >
                        <Icon type="file-pdf" />
                        <br></br>
                        ดูไฟล์ PDF
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ),
          okText: "ปิด",
          onOk() {},
        });
      };
    }
  };

  modalShowFileDatabase = async (dataFile) => {
    console.log("modalShowFileDatabase", dataFile);

    if (dataFile.fileType !== "application/pdf") {
      Modal.info({
        className: "modalFickIcons pt-4",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "800px",
        content: (
          <div>
            <hr></hr>
            <div className="pt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col span={8} style={{ display: "block" }}>
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      padding: "10px 55px",
                    }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <img
                      src={checkLinkURL() + dataFile.file}
                      className="zoom-in"
                    />
                    <a
                      onClick={() =>
                        this.onClickToNewTabDatabase(
                          dataFile.fileType,
                          checkLinkURL() + dataFile.file
                        )
                      }
                      className="icons-delect-images"
                    >
                      <Icon type="eye" style={{ color: "#fff" }} />
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    } else {
      Modal.info({
        className: "modalFickIcons pt-4",
        title: "ไฟล์อัปโหลดเอกสารแนบ",
        width: "800px",
        content: (
          <div>
            <hr></hr>
            <div className="pt-4">
              <Row gutter={16} type="flex" justify="left" align="top">
                <Col span={8} style={{ display: "block" }}>
                  <div
                    style={{ width: "100%", height: "200px" }}
                    align="center"
                    className="block-show-image-modal"
                  >
                    <a
                      onClick={() =>
                        this.onClickToNewTabDatabase(
                          dataFile.fileType,
                          checkLinkURL() + dataFile.file
                        )
                      }
                      className="color-white"
                    >
                      <Icon type="file-pdf" />
                      <br></br>
                      ดูไฟล์ PDF
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        ),
        okText: "ปิด",
        onOk() {},
      });
    }
  };

  destroyArrayDataUploads = async (arrayId, diasterAttachId = null, record) => {
    const { form, onChangeDeletedAttachment } = this.props;
    const { dataTalbeUploads } = this.state;
    var arrayDataSource = [...this.state.dataTalbeUploads];
    arrayDataSource.splice(arrayId, 1);

    //await this.hideModalConfirm();
    console.log("arrayDataSource before", arrayDataSource);
    console.log("destroyArray", arrayId);
    console.log("diasterAttachId", diasterAttachId);

    if (diasterAttachId) {
      console.log("record destroyArrayDataUploads",record)
      onChangeDeletedAttachment(record);
    }
    await this.setState(
      {
        dataTalbeUploads: arrayDataSource,
        // dataTalbeLength: lengthData
      },
      async () => {
        //await this.props.onTableChange(arrayDataSource);
        let lengthData = arrayDataSource.length;
        await this.setState({
          dataTalbeLength: lengthData,
        });

        const fieldsBeforeMap = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord fieldsBefore map", fieldsBeforeMap);

        console.log("arrayDataSource.file", arrayDataSource);
        // arrayDataSource.map(async (valuesTable, keysTable) => {
        //   let documentType = `documentType${keysTable}`;
        //   let description = `description${keysTable}`;

        //   let file = `file${keysTable}`;
        //   // let studyFileName = `studyFileName${keysTable}`;

        //   const fieldsBefore = this.props.form.getFieldsValue();
        //   //const { studyRecord } = fields
        //   console.log("studyRecord fieldsBefore2", fieldsBefore);

        //   await this.props.form.setFieldsValue({
        //     [documentType]: valuesTable.documentType,
        //     [description]: valuesTable.description,
        //     //[studyFileName]: valuesTable.studyFileName,
        //   });
        //   // console.log("arrayDataSource valuesTable.file", valuesTable);
        //   // console.log("arrayDataSource this.props.form", this.props.form);
        //   const fieldsX = this.props.form.getFieldsValue();
        //   //const { studyRecord } = fields
        //   console.log("studyRecord map", fieldsX);
        // });
       

           await this.props.form.setFieldsValue({
            disasterAttachfile : arrayDataSource
          });

 const fields = this.props.form.getFieldsValue();
        //const { studyRecord } = fields
        console.log("studyRecord", fields);
        console.log("arrayDataSource after", arrayDataSource);
      }
    );
  };

  showDataInputUploads = async () => {
    const { formRef, detailForm, form } = this.props;
    const { dataTalbeUploads, studyLearnRecord } = this.state;

    //console.log("form upload", form.getFieldsValue());

    const rows = {
      // docId: "",
      documentType: "เอกสารประกอบการเบิกเงินช่วยเหลือผู้ประสบภัยพิบัติ",
      description: "",
      file: null,
      // isNew: true,
      // isShowEditButton: false,
      // isShowSaveButton: true,
      // isValidate: false,
      // disabledRow: false,
    };

    await this.setState(
      (prevState) => ({
        dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        disabledAdd: true,
      }),
      async () => {
        let lengthData = dataTalbeUploads.length + 1;
        await this.setState({
          dataTalbeLength: lengthData,
        });
        // const fields = formRef.current.getFieldsValue()
        // const { studyLearnRecord } = fields

        console.log("dataTalbeUploads", dataTalbeUploads);
      }
    );
  };

  hideModalConfirm = () => {
    console.log("hidemodal");
    this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
      ModalConfirmFormSubmitToSend: null,
    });
  };

  handleDeleteRecord = (      destroyArrayId,
    destroyStudyLearnRecordId,
    deleteRecord) => {
    this.hideModalConfirm();

    this.destroyArrayDataUploads(      destroyArrayId,
      destroyStudyLearnRecordId,
      deleteRecord);
  };

  async componentDidMount() {
    const { match, rawData } = this.props;

    if (rawData) {
      // const mergeData = rawData.map((obj, _index) => ({
      //   ...obj,
      //   disabledRow: true,
      //   isShowEditButton: false,
      //   isShowSaveButton: false,
      //   isValidate: true,
      // }));

      await this.setState({
        dataTalbeUploads: rawData,
      });
    }

    {console.log("ATTACHMENT SEC",rawData)}
  }

  render() {
    const { match, rawData, isViewOnly, rawDataDoc, form } = this.props;
    const {
      loadingFullpage,
      columns,
      dataTalbeUploads,
      ModalConfirmFormShowModal,
      ModalFormTextArea,
      destroyArrayId,
      destroyStudyLearnRecordId,
      deleteRecord
    } = this.state;
    // const { getFieldDecorator } = this.props.form;

    return (
      <>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
            <Text className="color-red" style={{ fontSize: "18px" }}>เอกสารแนบ</Text>
          </Col>
          <Modal
            destroyOnClose={true}
            visible={ModalConfirmFormShowModal}
            maskClosable={false}
            title="ท่านต้องการลบข้อมูล?"
            // onOk={ () =>{
            //     this.onSubmit()
            // }}
            onCancel={() => {
              this.hideModalConfirm();
            }}
            width={600}
            okText={"ยืนยัน"}
            cancelText={"ยกเลิก"}
            footer={null}
            className={ModalFormTextArea ? "showTextArrea" : ""}
          >
            {ModalFormTextArea ? (
              <>
                {
                  //subtitle &&
                  <span>{/* {subtitle} */}</span>
                }

                <Form
                //ref={this.formRef}
                >
                  <Row gutter={16} type="flex" justify="left" align="top">
                    <Col xs={24} md={24}>
                      <Form.Item label={"หมายเหตุ"}>
                        {this.props.form.getFieldDecorator("noteApprove", {
                          initialValue: "",
                          rules: [
                            {
                              //required: ModalFormTextAreaRequie,
                              message: "กรุณากรอก หมายเหตุ",
                            },
                          ],
                        })(<TextArea rows={3} className="block-news" />)}
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={24} align={"right"}>
                      <Button
                        type="primary"
                        className="mt-1 mr-3 btn-white-red"
                        //	disabled={ preLoadOnsubmit }
                        // onClick={ this.searchForm }
                        onClick={this.hideModalConfirm()}
                      >
                        ยกเลิก
                      </Button>

                      <Button
                        type="primary "
                        className="mt-1 color-white"
                        htmlType="submit"
                        //disabled={ preLoadOnsubmit }
                        onClick={this.submitFormDelete()}
                      >
                        ยืนยัน
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </>
            ) : (
              <Form
              //ref={this.formRef}
              >
                <Row gutter={16} type="flex" justify="left" align="top">
                  {
                    // subtitle &&
                    // <Col xs={24} md={24} >
                    // 	<span>
                    // 		{subtitle}
                    // 	</span>
                    // </Col>
                  }
                  <Col xs={24} md={24} align={"right"}>
                    <Button
                      type="primary"
                      className="mt-1 mr-3 btn-white-red"
                      //disabled={ preLoadOnsubmit }
                      // onClick={ this.searchForm }
                      onClick={this.hideModalConfirm}
                    >
                      ยกเลิก
                    </Button>

                    <Button
                      type="primary "
                      className="mt-1 color-white"
                      htmlType="submit"
                      //disabled={ preLoadOnsubmit }
                      // onClick={ this.searchForm }
                      onClick={async () =>
                        //this.onSubmit()
                        this.handleDeleteRecord(      destroyArrayId,
                          destroyStudyLearnRecordId,
                          deleteRecord)
                      }
                    >
                      ยืนยัน
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal>
          <Col md={24} className="mb-2">

          <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          style={{marginLeft:"0px"}}
        >

            <Col md={8} className="mb-2">
              <Form.Item className="mb-0"   valuePropName={'checked'}>
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isDisasterRequest`,
                  {
                    initialValue:
                      rawDataDoc?.isDisasterRequest == 1 ||
                      rawData?.isDisasterRequest
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                    // checked={
                    //   rawDataDoc?.isDisasterRequest == 1 ||
                    //   rawData?.isDisasterRequest
                    //     ? true
                    //     : false
                    // }
                   // value={rawDataDoc?.isDisasterRequest == 1 ? true : false}
                   defaultChecked={
                      rawDataDoc?.isDisasterRequest == 1 ||
                      rawData?.isDisasterRequest
                        ? true
                        : false
                    }
                    disabled={isViewOnly}
                  >
                    คำขอรับเงินค่าช่วยเหลือประสบภัยพิบัติ <span class="color-red">*</span>
                  </Checkbox>
                )}
              </Form.Item>
              <Form.Item className="mb-0" hidden>
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].id`,
                  {
                    initialValue:
                      rawDataDoc?.id ?  rawDataDoc?.id
                        : null,
                    rules: [
                      {
                        required: false,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Input/>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isContractAndIdCard`,
                  {
                    initialValue:
                      rawDataDoc?.isContractAndIdCard == 1 ||
                      rawData?.isContractAndIdCard
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isContractAndIdCard == 1 ||
                      rawData?.isContractAndIdCard
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isContractAndIdCard == 1  || rawData?.isContractAndIdCard? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาหลักฐานการเช่า
                    หรือสำเนาหลักฐานการแสดงความเป็นเจ้าของกรรมสิทธิ์
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isIdCard`,
                  {
                    initialValue:
                      rawDataDoc?.isIdCard == 1 || rawData?.isIdCard
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isIdCard == 1 || rawData?.isIdCard
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isIdCard == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาบัตรประชาชน <span class="color-red">*</span>
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
</Row>

            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isEmpIdCard`,
                  {
                    initialValue:
                      rawDataDoc?.isEmpIdCard == 1 || rawData?.isEmpIdCard
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isEmpIdCard == 1 || rawData?.isEmpIdCard
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isEmpIdCard == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาบัตรประจำตัวบุคลากร <span class="color-red">*</span>
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isHouseRegis`,
                  {
                    initialValue:
                      rawDataDoc?.isHouseRegis == 1 ||
                      rawDataDoc?.isHouseRegis
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isHouseRegis == 1 ||
                      rawData?.isHouseRegis
                        ? true
                        : false
                    }
                    /// value={rawDataDoc?.isMarriageCertificate == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาใบทะเบียนบ้าน (ผู้ขอเบิก)
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isMarriageCertificate`,
                  {
                    initialValue:
                      rawDataDoc?.isMarriageCertificate == 1 ||
                      rawDataDoc?.isMarriageCertificate
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isMarriageCertificate == 1 ||
                      rawData?.isMarriageCertificate
                        ? true
                        : false
                    }
                    /// value={rawDataDoc?.isMarriageCertificate == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาใบสำคัญการสมรส (ถ้ามี)
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isChangeName`,
                  {
                    initialValue:
                      rawDataDoc?.isChangeName == 1 || rawData?.isChangeName
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isChangeName == 1 || rawData?.isChangeName
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isChangeName == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาใบเปลี่ยนชื่อ-สกุล (ถ้ามี)
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isDamageWarranty`,
                  {
                    initialValue:
                      rawDataDoc?.isDamageWarranty == 1 ||
                      rawData?.isDamageWarranty
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isDamageWarranty == 1 ||
                      rawData?.isDamageWarranty
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isDamageWarranty == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    หนังสือรับรองที่ออกให้โดยส่วนราชการส่วนท้องถิ่น <span class="color-red">*</span>
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isResidentWarranty`,
                  {
                    initialValue:
                      rawDataDoc?.isResidentWarranty == 1 ||
                      rawData?.isResidentWarranty
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isResidentWarranty == 1 ||
                      rawData?.isResidentWarranty
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isResidentWarranty == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    แบบรับรองและยืนยันการพักอาศัยของตัวบุคคลในบ้าน
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isHostDoc`,
                  {
                    initialValue:
                      rawDataDoc?.isHostDoc == 1 || rawData?.isHostDoc
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isHostDoc == 1 || rawData?.isHostDoc
                        ? true
                        : false
                    }
                    //value={rawDataDoc?.isHostDoc == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    สำเนาทะเบียนบ้าน และสำเนาบัตรประจำตัวประชาชน (ผู้รับรอง)
                  </Checkbox>
                )}
              </Form.Item>
            </Col>
            <Col md={8} className="mb-2">
              <Form.Item className="mb-0">
                {this.props.form.getFieldDecorator(
                  `disasterDocument[0].isPhoto`,
                  {
                    initialValue:
                      rawDataDoc?.isPhoto == 1 || rawData?.isPhoto
                        ? true
                        : false,
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  }
                )(
                  <Checkbox
                  defaultChecked={
                      rawDataDoc?.isPhoto == 1 || rawData?.isPhoto
                        ? true
                        : false
                    }
                    // value={rawDataDoc?.isPhoto == 1 ? true : false}
                    disabled={isViewOnly}
                  >
                    ภาพถ่ายบ้านและทรัยพ์สินที่ได้รับความเสียหาย <span class="color-red">*</span>
                  </Checkbox>
                )}
              </Form.Item>
            </Col>

            <Form.Item className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={dataTalbeUploads}
              pagination={false}
            />
            {!isViewOnly && (
              <Col md={24} className="mb-2 mt-2" align="right">
                <Button
                  style={{ display: "inline-block" }}
                  type="primary btn-color-default btn-custom btn-clear color-white"
                  className="mt-1 mr-2"
                  align="right"
                  onClick={() =>
                    //dataTalbeUploads.lenght > 0
                    //</Col>? this.checkBeforeAddRow("new")
                    //:
                    this.showDataInputUploads()
                  }
                  //disabled={disabledAdd ? true : false}
                >
                  เพิ่มแถว
                </Button>
              </Col>
            )}
          </Col>
        </Row>
      </>
    );
  }
}

WelfareListPaymentVictimSecAttachment.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimSecAttachment.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimSecAttachment = Form.create()(
  WelfareListPaymentVictimSecAttachment
);

export default withApollo(WrappedWelfareListPaymentVictimSecAttachment);
